import ActiveRecordResource from '../ActiveRecordResource';
import config from 'config';
import { UserDTO } from '../manager';

import { ImageDTO, Image } from "../image";

export interface FanFeedSlideshowPostDTO {
  id?: string;
  created_by: UserDTO;
  created_at: number;
  publish_at?: number;
  image_urls: ImageDTO
  tags: string[]
  video_url: string
  status: string
  text: string
}


export default class FanFeedSlideshowPost extends ActiveRecordResource {
  static path = `${config.backOfficeBasePath}/fan_feed/posts/random_list`;

  static mapRecords(data) {
    return data.map((item) => this.parseData(item));
  }

  static parseData(data: FanFeedSlideshowPostDTO): FanFeedSlideshowPost {
    let res = new FanFeedSlideshowPost({});

    return Object.assign(res, res._parseData(data));
  }

  createDate: Date;
  image: Image;
  tags: string[] = []
  video_url: string
  status: string
  text: string

  _getModel() {
    return FanFeedSlideshowPost;
  }

  _parseData(data: FanFeedSlideshowPostDTO) {
    let res: any = {
      id: data.id,
      image: data.image_urls ? new Image(Object.assign(new ImageDTO(), data.image_urls)) : null,
      tags: data.tags,
      video_url: data.video_url,
      createdBy: data.created_by,
      status: data.status,
      text: data.text,
      createDate: new Date(data.created_at),
    };

    return res;
  }
  
}



// WEBPACK FOOTER //
// ./src/api/fan_feed/fan_feed_slideshow.ts